"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalForageStrategy = void 0;
var localforage_1 = __importDefault(require("localforage"));
var LocalForageStrategy = /** @class */ (function () {
    function LocalForageStrategy() {
        var localForageConfig = localforage_1.default.config();
        if (localForageConfig && localForageConfig.storeName !== 'store') {
            localforage_1.default.config({
                name: 'proximus',
                version: 2,
                storeName: 'store',
            });
        }
    }
    // NOTE: Should we reject empty values?
    LocalForageStrategy.prototype.getItem = function (key) {
        return localforage_1.default.getItem(key).then(function (value) {
            return new Promise(function (resolve, reject) {
                if (value == null || typeof value === 'undefined') {
                    reject();
                }
                resolve(value);
            });
        }, function (err) {
            return Promise.reject(err);
        });
    };
    LocalForageStrategy.prototype.setItem = function (key, object) {
        return localforage_1.default.setItem(key, object);
    };
    LocalForageStrategy.prototype.removeItem = function (key) {
        return localforage_1.default.removeItem(key);
    };
    LocalForageStrategy.prototype.clear = function () {
        return localforage_1.default.clear();
    };
    LocalForageStrategy.ID = 'localForage';
    return LocalForageStrategy;
}());
exports.LocalForageStrategy = LocalForageStrategy;
